import React, { FC } from "react";
import { ActivityIndicator, View } from "react-native";
import Colors from "../../constants/Colors";

interface IProps {
  size?: number;
  color?: string;
  noPadding?: boolean;
}

const Spinner: FC<IProps> = ({ size, color, noPadding }) => {
  return (
    <View
      style={{
        alignItems: "center",
        alignContent: "center",
        justifyContent: "center",
        padding: noPadding ? undefined : 30,
      }}
    >
      <ActivityIndicator size={size || 24} color={color || Colors.gray[100]} />
    </View>
  );
};

export default Spinner;
